import { render, staticRenderFns } from "./BaseNav.vue?vue&type=template&id=47fffa72&scoped=true&"
import script from "./BaseNav.vue?vue&type=script&lang=js&"
export * from "./BaseNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fffa72",
  null
  
)

export default component.exports